module.exports = __webpack_public_path__ + "img/icon_download_bottom.8aaa721f.png";